type PrivilegeUsers = "super" | "admin" | "auditor" | "associate" | "customer" | "reseller" | "dev";

interface PrivilegeParams {
    name: string;
    desc: string;
    on?: PrivilegeUsers[];
}

export type PrivilegeMap = Record<
    string,
    {
        name: string;
        privileges: PrivilegeParams[];
    }
>;

export const privilegeMap = {
    admin: {
        name: "Admin",
        privileges: [
            { name: "access", desc: "Lihat", on: ["super"] },
            { name: "create", desc: "Tambah", on: ["super"] },
            { name: "update", desc: "Ubah", on: ["super"] },
            { name: "delete", desc: "Hapus", on: ["super"] },
        ],
    },
    privilege: {
        name: "Hak Akses",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["admin", "associate"] },
            { name: "delete", desc: "Hapus", on: ["admin", "associate"] },
        ],
    },
    auditor: {
        name: "Auditor",
        privileges: [
            { name: "access", desc: "Lihat", on: ["super"] },
            { name: "update", desc: "Ubah", on: ["super"] },
        ],
    },
    audit: {
        name: "Audit",
        privileges: [
            { name: "access", desc: "Lihat", on: ["auditor"] },
            { name: "update", desc: "Ubah", on: ["admin"] },
            { name: "updateSkip", desc: "Ubah Skip", on: [] },
        ],
    },
    associate: {
        name: "Mitra",
        privileges: [
            { name: "admin", desc: "Admin", on: [] },
            { name: "access", desc: "Lihat", on: ["admin"] },
            { name: "create", desc: "Tambah", on: ["admin"] },
            { name: "update", desc: "Ubah", on: ["admin"] },
            { name: "delete", desc: "Hapus", on: ["admin"] },
            { name: "settings", desc: "Pengaturan", on: ["associate"] },
        ],
    },
    associateUser: {
        name: "Pengguna Mitra",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
            { name: "agent", desc: "Agen", on: [] },
            { name: "marketing", desc: "Marketing", on: [] },
        ],
    },
    customer: {
        name: "Pelanggan",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
            { name: "profile", desc: "Profil", on: ["customer"] },
        ],
    },
    customerInvoice: {
        name: "Tagihan Pelanggan",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    productBroadband: {
        name: "Produk Broadband",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    productHotspot: {
        name: "Produk Hotspot",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    hotspotVoucher: {
        name: "Voucher Hotspot",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    radiusNAS: {
        name: "Radius NAS",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    radiusProfile: {
        name: "Profil RADIUS",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    radiusServer: {
        name: "Server RADIUS",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["dev"] },
        ],
    },
    reseller: {
        name: "Reseller",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate", "reseller"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
            { name: "profile", desc: "Profil", on: ["reseller"] },
        ],
    },
    financeAccount: {
        name: "Akun Finansial",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    financeInvoice: {
        name: "Faktur & Tagihan",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    financeTax: {
        name: "Setoran Pajak",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["admin"] },
        ],
    },
    legals: {
        name: "Dokumen Legalitas",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "auditor", "associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "updateCompany", desc: "Ubah", on: ["admin"] },
        ],
    },
    subscription: {
        name: "Langganan",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    // TODO: Rename to networkPOP
    locationPOP: {
        name: "Lokasi POP",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    networkOLT: {
        name: "OLT",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
        ],
    },
    networkONT: {
        name: "ONT / CPE",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
        ],
    },
    networkGroup: {
        name: "Jaringan IPv4",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    networkUsage: {
        name: "Alamat IPv4",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    warehouseItem: {
        name: "Barang",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    warehouseItemType: {
        name: "Jenis Barang",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    warehouseLocation: {
        name: "Lokasi Gudang",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    warehouseRequest: {
        name: "Permintaan Barang",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    whatsApp: {
        name: "WhatsApp",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
        ],
    },
    settings: {
        name: "Pengaturan",
        privileges: [
            { name: "access", desc: "Lihat", on: ["super"] },
            { name: "update", desc: "Ubah", on: ["super"] },
        ],
    },
    apiKey: {
        name: "API Key",
        privileges: [
            { name: "access", desc: "Lihat", on: ["admin", "associate"] },
            { name: "create", desc: "Tambah", on: ["associate"] },
            { name: "update", desc: "Ubah", on: ["associate"] },
            { name: "delete", desc: "Hapus", on: ["associate"] },
        ],
    },
    dev: {
        name: "Developer",
        privileges: [{ name: "tools", desc: "Tools", on: ["dev"] }],
    },
    debug: {
        name: "Debugging Tools",
        privileges: [{ name: "tools", desc: "Tools", on: ["super"] }],
    },
} as const satisfies PrivilegeMap;

type Feature = keyof typeof privilegeMap;
type Methods<T extends Feature> = (typeof privilegeMap)[T]["privileges"][number]["name"];
type MethodMap<T> = T extends Feature ? `${T}.${Methods<T>}` : never;
export type PrivilegeNames = MethodMap<Feature>;

function createPrivilegeMap(kind: PrivilegeUsers) {
    const result = {} as PrivilegeMap;
    Object.keys(privilegeMap).forEach((name) => {
        const key = name as Feature;
        const feature = privilegeMap[key];
        const privileges = feature.privileges;
        const allowed = privileges.filter((p) => new Set(p.on ?? []).has(kind));

        if (allowed.length > 0) {
            result[key] = {
                name: feature.name,
                privileges: allowed.map((p) => ({ name: p.name, desc: p.desc })),
            };
        }
    });

    return result;
}

function createPrivilegeSet(kind: PrivilegeUsers) {
    const result = new Set<string>();
    Object.keys(privilegeMap).forEach((name) => {
        const key = name as Feature;
        const feature = privilegeMap[key];
        const privileges = feature.privileges;
        const allowed = privileges.filter((p) => new Set(p.on ?? []).has(kind));
        allowed.forEach((p) => result.add(`${name}.${p.name}`));
    });

    return result as Set<PrivilegeNames>;
}

export const privilegeMapAdmin = createPrivilegeMap("admin");
export const privilegeSetAdmin = createPrivilegeSet("admin");
export const privilegeMapAssociate = createPrivilegeMap("associate");
export const privilegeSetAssociate = createPrivilegeSet("associate");
export const privilegeSetCustomer = createPrivilegeSet("customer");
export const privilegeSetReseller = createPrivilegeSet("reseller");
export const privilegeSetAuditor = createPrivilegeSet("auditor");
export const privilegeSetSuper = createPrivilegeSet("super").union(privilegeSetAdmin) as Set<PrivilegeNames>;
export const privilegeSetDev = createPrivilegeSet("dev").union(privilegeSetSuper) as Set<PrivilegeNames>;
